import get from 'lodash/get'
import isString from 'lodash/isString'
import { hasClientErrorDisplay } from './legacyFieldValidation'
import type { LegacyValidationErrors } from './formFieldTypes'

export function defaultFormatFieldError (errorMessage: string, value: string): string {
  if (isString(errorMessage) && isString(value)) {
    return errorMessage.replace(/\$\{ passwordLength \}/, String(value.length))
  }
  return errorMessage
}

export type LegacyDisplayedErrorParams = {
  validationErrors?: LegacyValidationErrors
  validationError?: string
  validationErrorFormat?: (message: string, value: string) => string
  forceError?: string
  showError: boolean
  fieldErrorMessage?: string
  displayValue: unknown
}

export function getLegacyDisplayedError ({
  validationErrors,
  validationError,
  validationErrorFormat,
  forceError,
  showError,
  fieldErrorMessage,
  displayValue,
}: LegacyDisplayedErrorParams): string | null {
  const canShowClientError = hasClientErrorDisplay({
    validationErrors,
    validationError,
    forceError,
  })

  if (forceError && (showError || forceError)) {
    const forced = get(validationErrors, forceError, validationError)
    return forced != null ? String(forced) : null
  }

  if (!(showError || forceError)) {
    return null
  }

  if (fieldErrorMessage) {
    const formatErrorFn = validationErrorFormat || defaultFormatFieldError
    return formatErrorFn(fieldErrorMessage, String(displayValue ?? ''))
  }

  if (!canShowClientError) {
    return null
  }

  return null
}
